import {
  ESortQueryKeys,
  ESortQueryValues,
} from '@ucheba/store/institutions/programs/types'

export const types = {
  height: [1002, 1, 2],
  master: [3],
  postgraduate: [4],
  mba: [1005, 51, 52, 53, 54, 55, 56, 57],
  vocational: [1001, 11, 12],
  school: [1000, 21, 22, 23, 24],
  course: [1004, 41, 42, 43],
  preparatory: [1003, 31, 32, 33, 34, 35, 36, 37, 38],
}

export const queryKeys = [
  {
    name: 'Стоимость до',
    key: 'priceTo',
    withValue: true,
  },
  {
    name: 'Стоимость от',
    key: 'priceFrom',
    withValue: true,
  },
  {
    name: '',
    key: 'tagIds',
  },
  {
    name: '',
    key: 'trainingFormTypeIds',
  },
  {
    name: '',
    key: 'programTypeIds',
  },
  {
    name: '',
    key: 'sale',
  },
  {
    name: 'Без экзаменов',
    key: 'withoutExams',
  },
  {
    name: '',
    key: 'subjectIds',
  },
]

export const sortItems: {
  key: string
  direction: string
  name: string
  types?: number[]
}[] = [
  {
    key: '',
    direction: '',
    name: 'Без сортировки',
  },
  {
    key: ESortQueryKeys.price,
    direction: ESortQueryValues.asc,
    name: 'Стоимость по возрастанию',
  },
  {
    key: ESortQueryKeys.price,
    direction: ESortQueryValues.desc,
    name: 'Стоимость по убыванию',
  },
  {
    key: ESortQueryKeys.date,
    direction: ESortQueryValues.asc,
    name: 'Дата старта по возрастанию',
    types: [...types.mba, ...types.course, ...types.school],
  },
  {
    key: ESortQueryKeys.date,
    direction: ESortQueryValues.desc,
    name: 'Дата старта по убыванию',
    types: [...types.mba, ...types.course, ...types.school],
  },
  {
    key: ESortQueryKeys.duration,
    direction: ESortQueryValues.asc,
    name: 'Длительность по возрастанию',
    types: [...types.mba, ...types.course, ...types.school],
  },
  {
    key: ESortQueryKeys.duration,
    direction: ESortQueryValues.desc,
    name: 'Длительность по убыванию',
    types: [...types.mba, ...types.course, ...types.school],
  },
  {
    key: ESortQueryKeys.budgetPlaces,
    direction: ESortQueryValues.asc,
    name: 'Кол-во бюджетных мест по возрастанию',
    types: [...types.height, ...types.master, ...types.vocational],
  },
  {
    key: ESortQueryKeys.budgetPlaces,
    direction: ESortQueryValues.desc,
    name: 'Кол-во бюджетных мест по убыванию',
    types: [...types.height, ...types.master, ...types.vocational],
  },
  {
    key: ESortQueryKeys.averageBySubjectExamScore,
    direction: ESortQueryValues.asc,
    name: 'Средний балл по предметам ЕГЭ по возрастанию',
    types: types.height,
  },
  {
    key: ESortQueryKeys.averageBySubjectExamScore,
    direction: ESortQueryValues.desc,
    name: 'Средний балл по предметам ЕГЭ по убыванию',
    types: types.height,
  },
  {
    key: ESortQueryKeys.diplomaAvgScore,
    direction: ESortQueryValues.asc,
    name: 'Средний балл аттестата по возрастанию',
    types: types.vocational,
  },
  {
    key: ESortQueryKeys.diplomaAvgScore,
    direction: ESortQueryValues.desc,
    name: 'Средний балл аттестата по убыванию',
    types: types.vocational,
  },
]

export const extraFacets = {
  hasAdditionalExam: [
    {
      name: 'Только без экзаменов',
      value: 0,
      count: 1,
    },
  ],
  sale: [
    {
      name: 'Только со скидкой',
      value: 1,
      count: 1,
    },
  ],
}
